
import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";

@Component
export default class TimeFrameSelector extends Vue {
  // 📃 Possible time frame filters
  private TIME_FRAME_OPTIONS = [
    { key: "Last 24H", value: 1 },
    { key: "Last 7D", value: 7 },
    { key: "Last 30D", value: 30 },
    { key: "Last 90D", value: 90 },
    { key: "Since Start", value: null },
  ];

  // 📦 The currently selected time frame option by which the bots' data is updated
  private get selectedTimeFrame(): number | null {
    return this.$store.state.userPreferences.selectedDashboardTimeFrame;
  }

  /**
   * 👂 Listener for changes on the selected time frame
   */
  @Watch("selectedTimeFrame")
  private onChange(val: number | null, oldVal?: number) {
    this.updateUrlQueryParameters(
      this.$store.state.userPreferences.selectedDashboardTimeFrame
    );
  }

  protected mounted() {
    this.updateUrlQueryParameters(this.selectedTimeFrame);

    // Parse the current URL and change the timeframe parameter if needed
    const urlTimeFrame = Number(this.$route.query.timeframe);
    if (!urlTimeFrame) {
      return;
    }
    if (
      this.TIME_FRAME_OPTIONS.map((option: any) => option.value).includes(
        urlTimeFrame
      )
    ) {
      this.$store.dispatch("changeDashboardTimeFrame", urlTimeFrame);
    } else {
      this.$store.dispatch("changeDashboardTimeFrame", null);
      this.updateUrlQueryParameters(null);
    }
  }

  /**
   * 🏗 Makes changes to the url and appends/removes the timeframe parameter
   */
  private updateUrlQueryParameters(timeframe: number | null) {
    let parameter: any = timeframe
      ? {
          query: {
            timeframe,
          },
        }
      : {};
    this.$router.replace(parameter);
  }
}
